import React from 'react';
import Angle from './Angle';

export default function AnglesList({list}) {
  if (!list) {return "Error: no angles list provided";}
  return <div className="angle-list">
    {list.map((a, i) => <Angle data={a} key={i} listItem />)}
  </div>;
};
